import React, { type PropsWithChildren } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

export const MergedCell = ({ children }: PropsWithChildren) => {
	return (
		<Box xcss={cellStyles} tabIndex={0}>
			{children}
		</Box>
	);
};

const cellStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	height: ' 100%',
	paddingLeft: 'space.100',
	position: 'relative',
});
